import List from 'antd/es/list';
import styled from 'styled-components';

export const SearchBarList = styled(List)`
  &&& {
    width: 100%;
    max-height: 300px;
    overflow-y: scroll;
    position: relative;

    .setur-list-split,
    .setur-list-item {
      border-bottom: none;
    }
    @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
      max-height: initial;

      grid-row: 2/3;
      width: 100%;
      height: 100%;
      overflow: auto;
      transition: all 0.5s;
    }
  }
`;

export const SearchBarListItem = styled(List.Item)`
  padding: 15px !important;
  border-bottom: none !important;
  display: flex !important;
  justify-content: center !important;
  cursor: pointer;

  :hover {
    background-color: ${({ theme }) => theme.palette.primaryBrandSoft};
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 15px 0px;
  }
`;

export const ItemTextWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex: 1;
  flex-direction: column;
`;

export const ItemText = styled.div`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;

  b {
    font-weight: 600;
  }
`;

export const ItemTextCity = styled.div`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;

  b {
    font-weight: 600;
  }
`;
